module.exports = __webpack_public_path__ + "img/btn_menu_xmmg.70ae5368.png";